import type { RichEditorPreset } from '@odo/shared-ui';
import { toDoc } from './docBuilders';
import { filled, type VcaNoteFields } from './noteFields';

export function midTxRefinementNotesPreset(fields: VcaNoteFields): RichEditorPreset {
    const f = filled(fields);
    return {
        id: 'mid-tx-refinement',
        label: 'Mid TX refinement',
        description: 'Doctor filled in; add the reason for the evaluation and edit the rest.',
        doc: toDoc([
            [[`Good Morning/Afternoon Dr. ${f.doctor},`]],
            [
                [
                    'Please schedule an in-office visit for a ',
                    { bold: 'refinement evaluation' },
                    ' due to [DETAILED REASON].'
                ]
            ],
            [
                [
                    'The patient’s monitoring has been ',
                    { bold: 'paused' },
                    ' and they’ve been instructed to ',
                    { bold: 'remain in their current aligner' },
                    ' until evaluated.'
                ]
            ],
            [
                [
                    { bold: 'Recommendation for pediatric/mixed dentition cases:' },
                    ' if aligners fit poorly from the previous set, a same-day retainer is highly recommended.'
                ]
            ],
            [['Thank you!']]
        ])
    };
}
